exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "need-a-loan .need-a-loan{padding-bottom:40px}need-a-loan .need-a-loan.responsiveMobile{min-height:100vh;margin-bottom:30px}need-a-loan .need-a-loan.responsiveMobile .need-a-loan-family-select-title h2,need-a-loan .need-a-loan.responsiveMobile header section-title h2{font-size:16px}need-a-loan h2{color:#0072c9}need-a-loan .remove-events{pointer-events:none}need-a-loan .need-a-loan-family-select-title{margin-bottom:20px}need-a-loan loans-sign-up-form-simulation-housing-change-warning{margin-top:40px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/features/needALoan/needALoan.scss
// module id = 2103
// module chunks = 0